import { FunctionComponent, useEffect, useMemo } from 'react';
import { inputStyles } from '../../Universal/NovusDSImports/variants';
import { useFormContext } from 'react-hook-form';
import { TextArea } from '../../Universal/NovusDSImports';
import { useReduxSelector } from '../../Store/reduxHooks';
import {
  createWeaTextMessageMap,
  removeEventManagedByLabel
} from '../../CommonUtilities/CommonUtilities';
import { RootState } from '../../store';

interface WEATextMessageTextAreaProps {
  name: string;
  maintainedBy: number | null;
  maxLength: number;
  nonMandatory?: boolean;
  [prop: string]: any;
}

const WEAMessageTextArea: FunctionComponent<WEATextMessageTextAreaProps> = (
  props
) => {
  const { name, maintainedBy, maxLength, nonMandatory } = props;

  const { setValue, getValues } = useFormContext();
  const eventMaintainers = useReduxSelector(
    (state: RootState) => state.Closures.eventMaintainers
  );
  const weaTextMessageMap = useMemo(() => {
    return createWeaTextMessageMap(eventMaintainers);
  }, [eventMaintainers]);

  useEffect(() => {
    const value: string = removeEventManagedByLabel(
      getValues(name),
      eventMaintainers
    );
    const prefix = weaTextMessageMap[maintainedBy ?? 'null'];
    if ((prefix + value).length > maxLength) {
      setValue(name, (prefix + value).slice(0, maxLength));
    } else {
      setValue(name, prefix + value);
    }
  }, [maintainedBy]);

  const isInputAllowed = (event) => {
    return (
      [
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'End',
        'Home',
        'Tab'
      ].includes(event.key) ||
      (event.ctrlKey && event.code === 'KeyC')
    );
  };

  const onKeyDown = (event) => {
    const invalidSelectionEnd =
      weaTextMessageMap[maintainedBy ?? 'null'].length;
    if (
      (maintainedBy && event.key === 'Backspace' && event.ctrlKey) ||
      ((event.target.selectionStart < invalidSelectionEnd ||
        (event.target.selectionEnd === invalidSelectionEnd &&
          event.key === 'Backspace') ||
        event.target.selectionEnd < invalidSelectionEnd) &&
        !isInputAllowed(event))
    ) {
      event.preventDefault();
    }
  };

  const onPaste = (event) => {
    const invalidSelectionEnd =
      weaTextMessageMap[maintainedBy ?? 'null'].length;
    if (event.target.selectionEnd < invalidSelectionEnd) {
      event.preventDefault();
    }
  };

  return (
    <TextArea
      {...inputStyles}
      onKeyDown={onKeyDown}
      rows={nonMandatory ? (getValues(name) ? 4 : 1) : 4}
      onPaste={onPaste}
      {...props}
    />
  );
};

export default WEAMessageTextArea;
